"use client";

import { createContext, useContext } from "react";

const DeviceContext = createContext<DeviceType>("desktop");

export function DeviceProvider({
  deviceType,
  children,
}: {
  deviceType: DeviceType;
  children: React.ReactNode;
}) {
  return (
    <DeviceContext.Provider value={deviceType}>
      {children}
    </DeviceContext.Provider>
  );
}

export function useDeviceType() {
  return useContext(DeviceContext);
}
